export default "__VITE_ASSET__ca920c5a__"